import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProgressBar from './ProgressBar';
import LoadingSpinner from './LoadingSpinner';

import CommError from '../../Shared/Errors/Errors'

import './DetailSurvey.css'

var answerMap = {
    "5": "Excellent",
    "4": "Very Good",
    "3": "Good",
    "2": "Fair",
    "1": "Poor",
    "0": ""
}

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const DetailSurvey = (
    {
        errDetail,
        errDetailClear,

        curDetail,
  
        isOpen,
        detailExportDetails,
        surveyDetailExportInformation,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onRequestCancel={onRequestCancel} style={styling}>
        <CommError error={errDetail.error} onClose={errDetailClear} />

        <div className="detailsurvey editpages productManagement">
            <h1 className="header">Survey Details</h1>
                
            <div className="row">
                <div className="col-md-12">
                    <span className="back pull-left" onClick={onRequestCancel}><i className="fa fa-arrow-circle-left"></i>Back</span>
                    <button className="btn btn-primary survey pull-right" onClick={surveyDetailExportInformation}>Export</button>
                </div>
                <span id="startExportDetail">
                    {
                        detailExportDetails.complete_export === false ?
                            <LoadingSpinner />
                        :
                            null
                    }
                </span>
                <span id="progress_bar"><strong> Export Progress: {detailExportDetails.percent_complete}%</strong>
                    <ProgressBar percentage={detailExportDetails.percent_complete} />
                </span>
            </div>
            
            <div className="row header">
                <div className="col-md-12">
                    <div className="detail-blk">
                        <p className="detail-blk-hdg">Survey Information</p>

                        <div className="row child-row">
                            <div className="col-md-4">
                                <p>Survey Number:</p>
                                <p id ="detailSurveyNumber">{curDetail.surveyNumber}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Proposal Number:</p>
                                <p>{curDetail.proposalNumber}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Customer Name:</p>
                                <p>{curDetail.customerName}</p>                               
                            </div>
                        </div>
                        <div className="row child-row">
                            <div className="col-md-4">
                                <p>Salesperson Name:</p>
                                <p>{curDetail.salesPersonName}</p>
                            </div>
                            <div className="col-md-4">
                                <p>Location:</p>
                                <p>{curDetail.location}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="detail-blk">
                        <p className="detail-blk-hdg">Survey Results</p>
                        {
                            curDetail.surveyQuestionsAndAnswers ?
                                curDetail.surveyQuestionsAndAnswers.map((question, index) => {
                                    return <div key={index} className="row child-row">
                                        <div className="row child-row">
                                            <div className="col-md-6">
                                                <p>{question.question}</p>
                                            </div>
                                            <div className="col-md-5">
                                                <p className="pull-right">{answerMap[question.answer]}</p>
                                            </div>
                                        </div>

                                        <div className="row child-row">
                                            <div className="col-md-1">
                                                <p>Comment:</p>
                                            </div>
                                            <div className="col-md-11">
                                                <textarea disabled defaultValue={question.comment} />
                                            </div>
                                        </div>
                                    </div>
                                })
                            : null
                        }

                        <div className="row child-row">
                            <div className="col-md-6">
                                <p>To show our gratitude we would like to offer you a gift:</p>
                            </div>
                            <div className="col-md-5">
                                <p className="pull-right">{curDetail.gift}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <span className="back pull-left" onClick={onRequestCancel}><i className="fa fa-arrow-circle-left"></i>Back</span>
                    <button className="btn btn-primary survey last pull-right" onClick={surveyDetailExportInformation}>Export</button>
                </div>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default DetailSurvey